function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPodcast = function SvgIconPodcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeMiterlimit: 1.5
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M100 4097.5c0 4.69-3.809 8.5-8.5 8.5s-8.5-3.81-8.5-8.5c0-4.69 3.809-8.5 8.5-8.5",
    style: {
      fill: "none",
      strokeWidth: "1.91px"
    },
    transform: "scale(-1.04787) rotate(-45 -4921.328 2167.542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 4097.5c0 4.69-3.809 8.5-8.5 8.5s-8.5-3.81-8.5-8.5c0-4.69 3.809-8.5 8.5-8.5",
    style: {
      fill: "none",
      strokeWidth: "3.47px"
    },
    transform: "scale(-.5763) rotate(-45 -4938.492 2174.366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 4097v9",
    style: {
      fill: "none",
      strokeWidth: "2.43px"
    },
    transform: "translate(-62.43 -3365.877) scale(.82463)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2107.05,
    cy: 290.586,
    r: 1.365,
    style: {
      fill: "none",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    },
    transform: "translate(-2094.485 -277.552)"
  }));
};
export default SvgIconPodcast;